// import React, { useState } from 'react';

// const CandidateRegistration = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     maritalStatus: '',
//     currentAddress: '',
//     permanentAddress: '',
//     email: '',
//     phone: '',
//     gender: '',
//     aadharNumber: '',
//     totalExperience: '',
//     previousCompany: '',
//     previousDesignation: '',
//     employmentDuration: '',
//     reasonForLeaving: '',
//     currentCTC: '',
//     expectedCTC: '',
//     noticePeriod: '',
//     dob: '',
//     qualification: '',
//     relevantExperience: '',
//     resume: null
//   });
//   const [errors, setErrors] = useState({});
//   const handleChange = (e) => {
//     const { name, value, type, files } = e.target;
//     setFormData({ ...formData, [name]: type === 'file' ? files[0] : value });

//     // Real-time validation
//     const newErrors = { ...errors };
//     if (name === 'phone' && !/^[0-9]{10}$/.test(value)) {
//       newErrors.phone = 'Phone number must be exactly 10 digits';
//     } else {
//       delete newErrors.phone;
//     }
//     if (name === 'aadharNumber' && value && !/^[0-9]*$/.test(value)) {
//       newErrors.aadharNumber = 'Aadhar number must contain only numbers';
//     } else {
//       delete newErrors.aadharNumber;
//     }
//     setErrors(newErrors);
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log('Submitting: ', formData);
//     try {
//       const response = await fetch('http://localhost:5000/api/candidates/register', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });
//       const data = await response.json();
//       alert(data.message);
//     } catch (error) {
//       console.error('Error:', error);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50">
//       <form onSubmit={handleSubmit} className="bg-white p-10 rounded-2xl shadow-xl w-full max-w-3xl">
//         <h2 className="text-3xl font-bold text-center text-blue-600 mb-8">Candidate Registration</h2>

//         <h3 className="text-xl font-semibold mb-4">Personal Information</h3>
//         <div className="grid grid-cols-2 gap-4">
//           <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//           <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//           <select name="maritalStatus" value={formData.maritalStatus} onChange={handleChange} className="w-full p-3 border rounded-xl" required>
//             <option value="">Select Marital Status</option>
//             <option value="Unmarried">Unmarried</option>
//             <option value="Married">Married</option>
//             {/* <option value="Divorced">Divorced</option>
//             <option value="Widowed">Widowed</option> */}
//           </select>
//           <input type="text" name="currentAddress" placeholder="Current Address" value={formData.currentAddress} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//           <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//           <input type="number" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} className="w-full p-3 border rounded-xl" required min="1000000000" max="9999999999" />
//           {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
//           <select name="gender" value={formData.gender} onChange={handleChange} className="w-full p-3 border rounded-xl" required>
//             <option value="">Select Gender</option>
//             <option value="Male">Male</option>
//             <option value="Female">Female</option>
//             <option value="Other">Other</option>
//           </select>
//           <input type="date" name="dob" placeholder="Date of Birth" value={formData.dob} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//         </div>

//         <h3 className="text-xl font-semibold mt-8 mb-4">Identification Details</h3>
//         <input type="text" name="aadharNumber" placeholder="Aadhar Number" value={formData.aadharNumber} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//           {errors.aadharNumber && <p className="text-red-500 text-sm">{errors.aadharNumber}</p>}

//         <h3 className="text-xl font-semibold mt-8 mb-4">Professional Information</h3>
//         <div className="grid grid-cols-2 gap-4">
//           <input type="number" name="totalExperience" placeholder="Total Work Experience (in years)" value={formData.totalExperience} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="text" name="previousCompany" placeholder="Previous Company" value={formData.previousCompany} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="text" name="previousDesignation" placeholder="Designation" value={formData.previousDesignation} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="text" name="employmentDuration" placeholder="Duration of Employment" value={formData.employmentDuration} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="text" name="reasonForLeaving" placeholder="Reason for Leaving" value={formData.reasonForLeaving} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="number" name="currentCTC" placeholder="Current CTC" value={formData.currentCTC} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="number" name="expectedCTC" placeholder="Expected CTC" value={formData.expectedCTC} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="text" name="noticePeriod" placeholder="Notice Period" value={formData.noticePeriod} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//           <input type="text" name="qualification" placeholder="Highest Qualification" value={formData.qualification} onChange={handleChange} className="w-full p-3 border rounded-xl" required />
//           <input type="text" name="relevantExperience" placeholder="Relevant Experience (if any)" value={formData.relevantExperience} onChange={handleChange} className="w-full p-3 border rounded-xl" />
//         </div>

//         <h3 className="text-xl font-semibold mt-8 mb-4">Document Uploads</h3>
//         <input type="file" name="resume" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleChange} className="w-full p-3 border rounded-xl" required />

//         <button type="submit" className="w-full mt-8 bg-blue-500 text-white p-3 rounded-xl text-lg font-semibold hover:bg-blue-600 transition">
//           Register
//         </button>
//       </form>
//     </div>
//   );
// };

// export default CandidateRegistration;



import React, { useState } from 'react';
import Header from '../components/header';

const CandidateRegistration = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    maritalStatus: '',
    currentAddress: '',
    permanentAddress: '',
    email: '',
    phone: '',
    gender: '',
    aadharNumber: '',
    totalExperience: '',
    previousCompany: '',
    previousDesignation: '',
    employmentDuration: '',
    reasonForLeaving: '',
    currentCTC: '',
    expectedCTC: '',
    noticePeriod: '',
    dob: '',
    qualification: '',
    relevantExperience: '',
    resume: null
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({ ...formData, [name]: type === 'file' ? files[0] : value });

    // Real-time validation
    const newErrors = { ...errors };
    if (name === 'phone' && !/^[0-9]{10}$/.test(value)) {
      newErrors.phone = 'Phone number must be exactly 10 digits';
    } else {
      delete newErrors.phone;
    }
    if (name === 'aadharNumber' && value && !/^[0-9]*$/.test(value)) {
      newErrors.aadharNumber = 'Aadhar number must contain only numbers';
    } else {
      delete newErrors.aadharNumber;
    }
    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Submitting: ', formData);
    try {
      const response = await fetch('http://localhost:5000/api/candidates/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      alert(data.message);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (<>
    <Header/>
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-3xl">
        <h2 className="text-xl md:text-3xl font-bold text-center text-[#39160d] mb-8">Candidate Registration</h2>


        <h3 className="text-md font-semibold mb-4">Identification Details</h3>
        <div className="space-y-2">
          <input type="text" name="aadharNumber" placeholder="Aadhar Number" value={formData.aadharNumber} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
          {errors.aadharNumber && <p className="text-red-500 text-sm">{errors.aadharNumber}</p>}
        </div>

        <h3 className="text-md font-semibold mt-8 mb-4">Personal Information</h3>
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
          <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
          <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
          <select name="maritalStatus" value={formData.maritalStatus} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required>
            <option value="">Select Marital Status</option>
            <option value="Unmarried">Unmarried</option>
            <option value="Married">Married</option>
          </select>
          <input type="text" name="currentAddress" placeholder="Current Address" value={formData.currentAddress} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
          <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
          <input type="number" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required min="1000000000" max="9999999999" />
          {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
          <select name="gender" value={formData.gender} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <input type="date" name="dob" placeholder="Date of Birth" value={formData.dob} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
        </div>

        <h3 className="text-md font-semibold mt-8 mb-4">Professional Information</h3>
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
          <input type="number" name="totalExperience" placeholder="Total Work Experience (in years)" value={formData.totalExperience} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="previousCompany" placeholder="Previous Company" value={formData.previousCompany} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="previousDesignation" placeholder="Designation" value={formData.previousDesignation} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="employmentDuration" placeholder="Duration of Employment" value={formData.employmentDuration} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="reasonForLeaving" placeholder="Reason for Leaving" value={formData.reasonForLeaving} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="number" name="currentCTC" placeholder="Current CTC" value={formData.currentCTC} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="number" name="expectedCTC" placeholder="Expected CTC" value={formData.expectedCTC} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="noticePeriod" placeholder="Notice Period" value={formData.noticePeriod} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="qualification" placeholder="Highest Qualification" value={formData.qualification} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />
          <input type="text" name="relevantExperience" placeholder="Relevant Experience (if any)" value={formData.relevantExperience} onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>

        <h3 className="text-md font-semibold mt-8 mb-4">Uploads Resume/CV</h3>
        <input type="file" name="resume" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleChange} className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" required />

        <button type="submit" className="w-full mt-8 bg-[#39160d] text-white p-3 rounded-xl text-lg font-semibold hover:bg-blue-600 transition">
          Register
        </button>
      </form>
    </div>
    </>
  );
};

export default CandidateRegistration;
